<p-orderList [value]="OrderList" dragdrop="true" responsive="true">
  <ng-template let-listItem pTemplate="item">
    <div class="p-helper-clearfix">
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4">{{listItem.RuleName}}
      </div>
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4" >
        <img *ngIf="listItem.CategoryFiles[0] && listItem.CategoryFiles[0].FilePath" [src]="listItem.CategoryFiles[0].FilePath" style="display:inline-block;margin:2px 0 2px 2px" width="28"
          height="28">
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2" style="display: flex;">
        {{listItem.IsActive ? 'Active': 'InActive'}}
      </div>
      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2" style="display: flex;">
        <a *ngIf="listItem.IsDelete===false" class="inline actions pointer" pTooltip="Edit details" tooltipPosition="top" (click)="editDetails(listItem)">
          <i class="fa fa-edit"></i>
				</a>
				<ara-record-actions *ngIf="listItem.IsDelete===false" [SourceId]="listItem.RuleId" ModuleName="CategoryItem" [ShowLabel]="false"
						[ShowCancel]="false" [ShowDelete]="true" [ShowRestate]="false" [Status]="'New'" (output)="deleteItem($event)"></ara-record-actions>
            <ara-record-actions *ngIf="listItem.IsDelete===true" [SourceId]="listItem.RuleId" ModuleName="CategoryItem" ShowRestore="true"
            [ShowLabel]="false" (output)="deleteItem($event)"></ara-record-actions>
            
 

          </div>
    </div>
  </ng-template>
</p-orderList>
<div class="text-center margin-top-10">
  <button class="btn btn-primary" (click)="prepareSequenceInfo()">Save Sequence</button>
</div>
